<!-- DEBUT: formulaire ajout en masse dans le module 'Operation d'identification' -->
<div class="row width-100 container-form-masse">
    <div class="col-md-4">
        <label class="title-file">{{ formMasseLibelle?.etape_1 }}</label>
        <div
            class="d-flex align-items-center justify-content-center container-button-telecharger"
        >
            <button
                pButton
                pRipple
                class="p-button-success"
                icon="pi pi-download"
                (click)="downloadModelXls()"
                [label]="libelleFile?.file1"
            ></button>
        </div>
    </div>
    <div class="col-md-4">
        <label class="title-file">{{ formMasseLibelle?.etape_2 }}</label>
        <div
            class="d-flex align-items-center justify-content-center container-button-telecharger"
        >
            <div class="input_file h-70">
                <label for="file">
                    <img src="assets/images/excel.png" width="50" />
                    <span [hidden]="fileName"
                        ><b>{{ libelleFile?.file2 }}</b></span
                    >
                    <span [hidden]="!fileName"
                        ><b>{{ fileName }}</b></span
                    >
                </label>
                <input
                    type="file"
                    id="file"
                    (change)="onExcelFileChange($event.target.files)"
                    accept=".xlsx, .xls"
                    name="file"
                />
            </div>
        </div>
    </div>
    <div class="col-md-4">
        <label class="title-file">{{ formMasseLibelle?.etape_3 }}</label>
        <div
            class="d-flex align-items-center justify-content-center container-button-telecharger"
        >
            <!-- <button pButton pRipple label="Vérifier" icon="pi pi-search" class="p-button-warning ms-3 w-100"
                (click)="checkFile()" [disabled]="arrayHeaderExcelFile?.length === 0"></button> -->
            <div>
                <button
                    pButton
                    pRipple
                    class="p-button-warning"
                    #buttonCheckFile
                    icon="pi pi-search"
                    (click)="checkFile()"
                    [disabled]="arrayHeaderExcelFile?.length === 0"
                    [label]="getButtonLabel()"
                ></button>
            </div>
            <!-- <div class="width-100" [ngStyle]="{'color': 'red', 'opacity': arrayHeaderExcelFile?.length !== 0 ? 1 : 0, 'opacity': formatData.length !== 0 ? 0 : 1 }">Veuillez verifier le fichier</div> -->
        </div>
    </div>
</div>
